import * as React from 'react';
import ReactDropzone, { ImageFile } from 'react-dropzone';
import { IdentificationDocumentFileComponent } from './IdentificationDocumentFileComponent';
import './IdentificationDocumentForm.css';

const FileDownload = require('react-file-download');

interface IdentificationDocumentsDropzoneProps {
  idFile?: File;
  noIdFileText: string;
  isIdFileText: string;
  noIdFileImg: string;
  handleChange: (key: string) => (value: string | File | boolean) => void;
  onDrop: (file: ImageFile[]) => void;
}

export class IdentificationDocumentDropzone extends React.Component<IdentificationDocumentsDropzoneProps> {

  private dropzone: ReactDropzone | null;

  public render(): React.ReactNode {
    return [
      (
        <ReactDropzone
          ref={ref => this.dropzone = ref}
          className="id-dropzone"
          disableClick={!!this.props.idFile}
          onDrop={this.props.onDrop}
          multiple={false}
          accept="image/*, application/pdf"
        >
          <IdentificationDocumentFileComponent
            idFile={this.props.idFile}
            noIdFileText={this.props.noIdFileText}
            isIdFileText={this.props.isIdFileText}
            noIdFileImg={this.props.noIdFileImg}
            handleChange={() => this.props.handleChange}
          />
        </ReactDropzone>
      ),
      this.showFormButtons(),
      (
        <p className="question-detail-id">
          Solo se aceptan imágenes PNG, GIF, JPG y documentos PDF.
        </p>
      ),
    ];
  }

  private openDialog(): void {
    if (this.dropzone) {
      this.dropzone.open();
    }
  }

  private showFormButtons(): React.ReactNode | void {
    if (this.props.idFile) {
      return (
        <div className="id-buttons-zone">
          <button
            className="button-id"
            onClick={() => this.openDialog()}
          >
            Actualizar DNI
          </button>
          <button
            className="button-id"
            onClick={() => {
              FileDownload(this.props.idFile, this.props.idFile!.name || 'documento');
            }}
          >
            Ver DNI
          </button>
        </div>
      );
    }
  }
}


// WEBPACK FOOTER //
// ./src/modules/commons/identification-document-file/IdentificationDocumentDropzone.tsx